export default "__VITE_ASSET__BTqrYgbE__"